import { Component, Input, Output, EventEmitter } from "@angular/core";
import { MapService } from './../../Services/map.service';
import { StorageService } from 'src/app/Services/storage.service';
import { ApiService } from 'src/app/Services/api.service';
import { LoaderService } from "src/app/Services/loader.service";


@Component({
    selector: 'add-member',
    templateUrl: './add-member.html'
})

export class AddMemberdirective {
    @Input() popup: boolean = false;
    @Input() title: string = 'Members';
    @Input() apiMethod: string = '';
    @Input() recordRefId: any = '';
    @Input() selectedRefId: any = {};
    @Input() maxSelection = 1000;
    @Input() restrictEmp:boolean = false;
    @Input() trasitMode;
    @Input() routeID;


    @Output() result: any = new EventEmitter();
    @Output() closeEvent: any = new EventEmitter();
    @Output() selectionFromSearch: any = new EventEmitter();

    public objKeys = Object.keys;
    selectedMemberView:boolean;
    mapSearchDebounceTimeOut = null;
    mapSearchDataLists = [];
    userData: any = {};
    page: number = 1;
    selectedRecords = {};
    selectAllCheckbox: boolean = false;

    noRecords: boolean = false;

    searchModel = {};
    fields = [];
    memberArray = [];
    apiQueue: boolean = false;

    activeTable:string = 'searchTable';

    fieldLists: any = [
        //     { name: 'name', checked: true, },
        // { name: 'gender', value: 'gender', checked: true, },
        // { name: 'workLocation' },
        // { name: 'shift', checked: true, },
        // { name: 'location', checked: true, }
    ]
    constructor(
        public mapService: MapService,
        public storage: StorageService,
        public api: ApiService,
        private loader: LoaderService
    ) {
        this.loader.show();
        this.userData = this.storage.get('userInfo');
    }


    ngOnInit() {
       
        setTimeout(() => {
            this.loadMap();
            this.getFieldList();

        }, 1000);

    }

    loadMap() {

    }
    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    fieldsSelected(fields) {
        this.fields = fields;
    }

    mapSearchFind(location) {

        clearTimeout(this.mapSearchDebounceTimeOut);
        // console.log('before throttle', location)
        this.mapSearchDebounceTimeOut = setTimeout(() => {
            // console.log('after throttle', location)

            this.mapService.geoCoding(location).then((locations: any) => {
                this.mapSearchDataLists = [];
                this.mapSearchDataLists = locations.map((item) => {
                    const lat = item['center'][1];
                    const lng = item['center'][0];
                    return {
                        name: item['name'] + ' lat,lng ' + lat + ',' + lng
                    }
                });
            }).catch((error) => {
                console.log(error)
            });


        }, 600);




    }

    isNumber(evt) {
        if ((evt.target.value.split('.')).length > 2) {
            evt.target.value = evt.target.value.slice(0, -1);
            return false;
        }
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        //    console.log(charCode) 
        if (charCode === 46) return true;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    }

    getFieldList() {
        this.apiQueue = true;
        let obj = {
            onlyFields: true
        }
        this.api[this.apiMethod](obj).then((res: any) => {
            this.apiQueue = false;
            if (res.status == 'success') {
                this.fieldLists = res.fields;
                this.getMemberInfo();
            }
        }).catch((err) => {
            this.apiQueue = false;
            console.log(err)
        })
    } 

    getMemberInfo() {

        this.apiQueue = true;
        // console.log('searchModel', this.searchModel)
        let obj = {
            orgID: this.userData.orgID, /// <<<<< restrict ORG ID Important
            // projection: this.fields.map((item) => { let tmp = {}; tmp[item.name] = 1; return tmp; }),
            unAssignedEmp:1,
            trasitMode:this.trasitMode,
            limit:25,
            routeID:this.routeID,
            page: this.page
        };

        for(let k in this.searchModel) obj[k]=this.searchModel[k];
    
        this.api[this.apiMethod](obj).then((res: any) => {
        this.apiQueue = false;
            if (res.status == 'success') {
                this.memberArray = res.data;
                if (this.memberArray.length === 0) this.noRecords = true;
                else this.noRecords = false;

                  let empIDs = Object.keys(this.selectedRefId);
                  this.memberArray.filter((member)=>{
                       if(empIDs.indexOf(member[this.recordRefId])!=-1){
                                this.selectedRecords[member[this.recordRefId]]= member;
                       }
                  });
                // get shiftwise employee list
            }
        }).catch((err) => {
            this.apiQueue = false;
            console.log(err)
        })
    }

    selectionChange(refId, record,event) {
        if (this.selectedRefId[refId] === undefined){
            if (this.selectedRecords[refId]) delete this.selectedRecords[refId];
            else this.selectedRecords[refId] = record;
        }
        event.stopPropagation();
    }

    toggleSelection() {
        if (this.selectAllCheckbox) {
            this.selectedRecords = {};
            this.memberArray.length > 0 && this.memberArray.map((record) => {
                if (this.selectedRefId[record[this.recordRefId]]!== undefined) {
                    this.selectedRecords[record[this.recordRefId]] = record;
                }
            });
            this.selectAllCheckbox = false;
        } else {
            this.memberArray.length > 0 && this.memberArray.map((record) => {
                if (this.selectedRefId[record[this.recordRefId]] === undefined) {
                    this.selectedRecords[record[this.recordRefId]] = record;
                }
            });
            this.selectAllCheckbox = true;
        }
    }

    submitRecords() {
        this.result.emit(this.selectedRecords);
        setTimeout(() => {
            this.closeEvent.emit(true);
        }, 100);
    }

    selectionFromSearchAction() {
        this.activeTable = 'searchTable';
        this.selectedMemberView = false;
        console.log(this.selectedRecords);
        /* this.selectionFromSearch.emit(this.searchModel);
        setTimeout(() => {
            this.closeEvent.emit(true);
        }, 100); */
    }
    selectedMembers(){
        this.selectedMemberView = true;
        this.activeTable = 'selectedTable';
        console.log(this.selectedRecords);
    }


}

/*

{
            title: 'Meddavakam', eta: 10.0, radius: 300,
            lat: 12.970225, lng: 80.214339, location: 'Chennai',
            employees: [
                { name: 'Aun kumar R', empid: 'asdd45666654' },
                { name: 'Bala P', empid: 'vbbbbn65896684' },
                { name: 'Ravi A', empid: 'kju7545666694' },
            ]
        },

        */